<template>
  <div class="mb-6 sm:mb-8">
    <div class="bg-gray-50 border border-gray-200 rounded-lg p-4 sm:p-6">
      <div class="flex items-start gap-3 sm:gap-4">
        <div class="flex-shrink-0">
          <div class="w-10 h-10 sm:w-12 sm:h-12 bg-blue-100 rounded-lg flex items-center justify-center">
            <i class="fas fa-gift text-blue-600 text-lg sm:text-xl"></i>
          </div>
        </div>
        <div class="flex-1 min-w-0">
          <h3 class="text-base sm:text-lg font-semibold text-black mb-2 leading-tight">
            Votre code de parrainage Efashion -10% sur toutes les commandes passées chez vous à vie
          </h3>
          <p class="text-sm sm:text-base text-black mb-3 sm:mb-4 leading-relaxed">
            À envoyer à tous vos clients et prospects et valable à vie si c'est la première fois qu'ils passent commande via Efashion* 
          </p>
          <div class="text-xs sm:text-sm text-black leading-relaxed">
            *Si l'acheteur est déjà inscrit sur Efashion ou a déjà passé commande chez vous, le code n'est pas valable. 
            Efashion ne prendra pas tout simplement pas de commission sur les commandes passées par vos acheteurs parrainés grâce au code.
          </div>
          
          <div class="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
            <div class="flex items-center gap-2 sm:gap-3 bg-white border border-gray-300 rounded-lg px-3 sm:px-4 py-2 sm:py-3 w-full sm:w-auto">
              <i class="fas fa-user text-black text-sm sm:text-base"></i>
              <span class="font-mono text-sm sm:text-lg font-semibold text-black truncate">{{ referralCode }}</span>
              <button 
                @click="copyReferralCode"
                class="p-1 sm:p-2 text-black hover:text-blue-600 transition-colors flex-shrink-0"
                title="Copier le code"
              >
                <i class="fas fa-copy text-sm sm:text-base"></i>
              </button>
            </div>
            <ActionButton
              label="Voir Template"
              icon="fas fa-eye"
              variant="secondary"
              @click="viewTemplate"
              class="w-full sm:w-auto"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ActionButton } from '@/components'

interface Props {
  referralCode: string
}

interface Emits {
  (e: 'copy'): void
  (e: 'view-template'): void
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const copyReferralCode = () => {
  emit('copy')
}

const viewTemplate = () => {
  emit('view-template')
}
</script> 